import React from "react";
import { ClockIcon } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { processSteps } from "../data/process";
import { ui } from "../data/ui";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
export function Process() {
  const {
    t,
    lang
  } = useLanguage();
  return <section id="process" aria-labelledby="process-title" className="bg-ink py-20 lg:py-28" data-id="element-315" data-mp="23did5sxhw0u3">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-316" data-mp="16pvnqeyu9iq5">
        <SectionHeading id="process-title" align="center" title={t(ui.process.title)} subtitle={t(ui.process.subtitle)} data-id="element-317" data-mp="1ap4cf5f0uqeu" />

        <ol className="relative mt-16 grid gap-10 lg:grid-cols-5 lg:gap-6" data-id="element-318" data-mp="1fnxiwdvw5h5i">
          <span className="absolute bottom-6 left-6 top-6 w-px bg-gold/50 lg:bottom-auto lg:left-[10%] lg:right-[10%] lg:h-px lg:w-auto" aria-hidden="true" data-id="element-319" data-mp="1kfpbsv2iryyt" />
          {processSteps.map((step, i) => {
          const Icon = step.icon;
          return <li key={step.title.en} className="relative" data-id="element-320" data-mp="19lr5r9bwsoqv" data-mpi={i}>
                <Reveal delay={i * 0.05} className="flex gap-5 lg:flex-col lg:items-center lg:text-center" data-id="element-321" data-mp="19n260z65bed8">
                  <span className="relative z-10 grid h-12 w-12 shrink-0 place-items-center rounded-full border-2 border-gold bg-ink text-gold" data-id="element-322" data-mp="10sxkmv9s6v53">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-323" data-mp="vsrr19jyaykd" />
                  </span>
                  <div className="lg:mt-6" data-id="element-324" data-mp="quzuu3c9wqad">
                    <p className="text-xs font-semibold uppercase tracking-[0.16em] text-gold" data-id="element-325" data-mp="qsn719ju3lpe">
                      {lang === "es" ? "Paso" : "Step"} {i + 1}
                    </p>
                    <h3 className="mt-2 font-display text-xl font-bold uppercase text-white" data-id="element-326" data-mp="hubire6fx004">{t(step.title)}</h3>
                    <p className="mt-3 text-[15px] leading-relaxed text-smoke" data-id="element-327" data-mp="cx1mbekmvo2s">{t(step.text)}</p>
                    <span className="mt-4 inline-flex items-center gap-1.5 rounded-full border border-gold/50 px-3 py-1 text-xs font-medium text-gold" data-id="element-328" data-mp="2c600fo423go7">
                      <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-329" data-mp="2qdcp5gh9xfir" />
                      {t(step.time)}
                    </span>
                  </div>
                </Reveal>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}